import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ItemisedDutyTaxBreakdownDTO } from '@app/features/calculators/models/Itemised-duty-tax-breakdown-dTO';
import { ItemisedDutyTaxBreakdown } from '../models/itemised-duty-tax-breakdown';
import { Paginated } from '../models/paginated.model';
import { ShipmentBase } from '../models/shipment-base.model';
@Injectable({
  providedIn: 'root',
})
export class ShipmentCalculatorService {
  private http = inject(HttpClient);

  baseURL = environment.apiUrl + 'ShipmentDutyAndTax';

  searchShipmentsByShipmentNumber(searchCriteria: any): Observable<Paginated> {
    return this.http.post<Paginated>(
      this.baseURL + '/Shipments',
      searchCriteria
    );
  }

  submitDutyAndTaxEstimates(
    shipmentId: string,
    estimatedTax: ItemisedDutyTaxBreakdown
  ): Observable<any> {
    return this.http.put<any>(
      this.baseURL + `/Estimate/${shipmentId}`,
      estimatedTax
    );
  }

  getShipmentDutyAndTax(
    shipmentId: string
  ): Observable<ItemisedDutyTaxBreakdownDTO> {
    return this.http.get<ItemisedDutyTaxBreakdownDTO>(
      `${this.baseURL}/${shipmentId}/Details`
    );
  }

  updateShipmentDutyAndTaxStatus(
    shipmentId: string,
    status: string
  ): Observable<ShipmentBase> {
    return this.http.put<ShipmentBase>(
      `${this.baseURL}/${shipmentId}/Status`,
      `"${status}"`,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  updateShipmentDutyAndTaxNote(
    shipmentId: string,
    note: string
  ): Observable<any> {
    return this.http.put<any>(
      `${this.baseURL}/${shipmentId}/Note`,
      `"${note}"`,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  getShipmentDutyAndTaxStatus(shipmentId: string): Observable<string> {
    return this.http.get<string>(`${this.baseURL}/${shipmentId}/Status`, {
      responseType: 'text' as 'json',
    });
  }

  approveDutyAndTaxForProcessing(shipmentid: string): Observable<any> {
    return this.http.put<any>(
      `${this.baseURL}/ApproveDutyAndTaxForProcessing/${shipmentid}`,
      null
    );
  }
}
